import { alpha, Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { sidebarOpenWidth, sidebarClosedWidth } from '@/constants/sidebar'

import { colors } from '@/theme/colors.theme'

const useStyles = makeStyles()((theme: Theme) => {
  const transitionTime = {
    easing: theme.transitions.easing.sharp,
    duration: 250,
    delay: 100,
  }

  return {
    sidebar: {
      height: '100%',
      zIndex: 1300,
      position: 'relative',

      '&.open': {
        width: sidebarOpenWidth,

        '& .openArrow': {
          left: 238,

          '& svg': {
            paddingLeft: 3,
          },
        },
      },

      '&.close': {
        width: sidebarClosedWidth,
      },

      '& .openArrow': {
        position: 'fixed',
        left: 64,
        top: 60,
        width: 26,
        height: 26,
        zIndex: 100,
        border: `1px dashed ${alpha(colors.white, 0.12)}`,
        borderRadius: '50%',
        cursor: 'pointer',
        backgroundColor: colors.nav,

        '& svg': {
          fontSize: 14,
          width: 26,
          textAlign: 'center',
          color: alpha(colors.white, 0.4),
        },
      },
    },
    sidebarFixed: {
      flexShrink: 0,
      whiteSpace: 'nowrap',
      overflowY: 'hidden',
      overflowX: 'hidden',
      backgroundColor: colors.nav,
      padding: '16px 0',
      display: 'flex',
      flexDirection: 'column',
      borderRight: `1px dashed ${alpha(colors.white, 0.12)}`,
      position: 'fixed',
      height: '100vh',

      '& .menuTitle': {
        display: 'block',
        marginTop: 10,
        marginBottom: 20,
        textTransform: 'uppercase',
        fontWeight: 400,
        fontSize: '12px',
      },
    },
    sidebarOpen: {
      width: sidebarOpenWidth,
    },
    sidebarClosed: {
      width: sidebarClosedWidth,
      '& .MuiTreeItem-iconContainer': {
        display: 'none',
      },
      '& .menuTitle': {
        display: 'none',
      },
    },
    link: {
      height: 40,
      padding: '4px',
      marginBottom: 15,
      position: 'relative',

      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.05),
        borderRadius: '8px',
      },
      '& .MuiListItemIcon-root': {
        marginLeft: 0,
        width: '37px',
        minWidth: '37px',
        '& .MuiSvgIcon-root': {
          margin: '0px auto',
          fontSize: 30,
          width: '35px',
          height: '35px',
          padding: '7px',
        },
      },
      '&.active': {
        background: alpha(colors.primary, 0.08),
        borderRadius: '8px',
        color: colors.primary,

        '& svg': {
          color: colors.primary,
        },
      },
      '& .MuiListItemText-root': {
        '& .MuiTypography-body1': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontWeight: 400,
        },
        '& + .MuiSvgIcon-root': {
          fontSize: 20,
          position: 'absolute',
          right: '10px',
          pointerEvents: 'none',
        },
      },
      '[class*="sidebarOpen"] &': {
        transition: theme.transitions.create(['width'], transitionTime),
        '& > .MuiSvgIcon-root': {
          opacity: 1,
          transition: theme.transitions.create(['opacity'], transitionTime),
        },
      },
      '[class*="sidebarClosed"] &': {
        width: 'auto',
        transition: theme.transitions.create(['width'], transitionTime),
        '& > .MuiSvgIcon-root': {
          opacity: 0,
          transition: theme.transitions.create(['opacity'], transitionTime),
        },
      },
    },

    linkInner: {
      height: 48,
      padding: '8px 4px',
      position: 'relative',
      color: alpha(colors.white, 0.9),
      borderRadius: 4,
      marginBottom: 4,
      '& svg': {
        fontSize: 8,
        marginLeft: 12,
        color: alpha(colors.white, 0.9),
      },
      '& .MuiListItemText-root': {
        paddingLeft: '3px',
        '& .MuiTypography-body1': {
          fontSize: 14,
        },
      },
      '&:hover, &.active': {
        backgroundColor: alpha(theme.palette.common.white, 0.05),

        borderRadius: '8px',
        color: theme.palette.common.white,
        '& .MuiTypography-body1': {
          fontWeight: 400,
        },
        '& svg': {
          color: colors.primary,
        },
      },
    },
  }
})

export default useStyles
